import {
  ghostBtnClass,
  mfgPrimaryBtnClass,
  mfgSolidDangerBtnClass,
} from "@/components/manufacturing/manufacturingSurfaceClasses";

export function ManufacturingModelsBulkBar({
  selectedCount,
  filteredCount,
  allFilteredSelected,
  busy,
  confirmEligibleCount = 0,
  archiveEligibleCount = 0,
  deleteEligibleCount = 0,
  canArchive = false,
  canPermanentlyDelete = false,
  onSelectAllFiltered,
  onClear,
  onEditCommon,
  onExportCsv,
  onExportPdf,
  onConfirmReview,
  onArchiveSelected,
  onDeletePermanently,
}: {
  selectedCount: number;
  filteredCount: number;
  allFilteredSelected: boolean;
  busy?: boolean;
  /** Selected models with needs_review and no pending materials. */
  confirmEligibleCount?: number;
  archiveEligibleCount?: number;
  deleteEligibleCount?: number;
  canArchive?: boolean;
  canPermanentlyDelete?: boolean;
  onSelectAllFiltered: () => void;
  onClear: () => void;
  onEditCommon: () => void;
  onExportCsv?: () => void;
  onExportPdf?: () => void;
  onConfirmReview?: () => void;
  onArchiveSelected?: () => void;
  onDeletePermanently?: () => void;
}) {
  if (selectedCount === 0) return null;
  return (
    <div className="sticky top-0 z-10 rounded-2xl border border-indigo-200 bg-indigo-50/80 px-3 py-3 shadow-sm backdrop-blur dark:border-indigo-800 dark:bg-indigo-950/60">
      <div className="flex flex-wrap items-center gap-2">
        <div className="text-sm font-medium text-indigo-900 dark:text-indigo-100">
          {selectedCount} model{selectedCount === 1 ? "" : "s"} selected
        </div>
        <button
          type="button"
          className={mfgPrimaryBtnClass}
          onClick={onEditCommon}
          disabled={busy}
        >
          Edit common…
        </button>
        {onConfirmReview && confirmEligibleCount > 0 ? (
          <button
            type="button"
            className={mfgPrimaryBtnClass}
            onClick={onConfirmReview}
            disabled={busy}
            title="Clear needs-review on selected models with no pending materials"
          >
            Confirm review ({confirmEligibleCount})
          </button>
        ) : null}
        {onExportCsv ? (
          <button type="button" className={ghostBtnClass} onClick={onExportCsv} disabled={busy}>
            Export CSV
          </button>
        ) : null}
        {onExportPdf ? (
          <button type="button" className={ghostBtnClass} onClick={onExportPdf} disabled={busy}>
            Export PDF
          </button>
        ) : null}
        {canArchive && onArchiveSelected && archiveEligibleCount > 0 ? (
          <button
            type="button"
            className={mfgSolidDangerBtnClass}
            onClick={onArchiveSelected}
            disabled={busy}
            title="Mark selected active models inactive"
          >
            Archive selected ({archiveEligibleCount})
          </button>
        ) : null}
        {canPermanentlyDelete && onDeletePermanently && deleteEligibleCount > 0 ? (
          <button
            type="button"
            className={mfgSolidDangerBtnClass}
            onClick={onDeletePermanently}
            disabled={busy}
            title="Permanently delete inactive selected models (cannot undo)"
          >
            Delete permanently ({deleteEligibleCount})
          </button>
        ) : null}
        {!allFilteredSelected && filteredCount > 0 ? (
          <button
            type="button"
            className={ghostBtnClass}
            onClick={onSelectAllFiltered}
            disabled={busy}
          >
            Select all filtered ({filteredCount})
          </button>
        ) : null}
        <button type="button" className={ghostBtnClass} onClick={onClear} disabled={busy}>
          Clear selection
        </button>
      </div>
      <p className="mt-2 text-[11px] text-indigo-800/80 dark:text-indigo-200/80">
        Export includes full BOM (materials, sub-recipes, part uses). Confirm review clears the
        needs-review flag on eligible selected models. Archive soft-deletes; permanent delete
        requires inactive models and an org owner role.
      </p>
    </div>
  );
}
